import cloneDeep from 'lodash.clonedeep';
import { select, put } from 'redux-saga/effects';

import { SetSceneTransitionDurationAction } from 'js/actionCreators/sceneTransitionsActions';
import { updateScribe } from 'js/actionCreators/scribeActions';
import { SCENE_TRANSITION_KEY_NONE } from 'js/config/consts';

import { getScribeById } from '../selectors';

import { getActiveSceneIds } from './getActiveSceneIds';

export function* setSceneTransitionDuration({ duration, scribeId, sceneIds }: SetSceneTransitionDurationAction) {
  const scribe = (yield select(getScribeById, scribeId)) as ReturnType<typeof getScribeById>;

  if (!scribe) return;

  const updatedScribe = cloneDeep(scribe);

  let sceneIdsToUse = getActiveSceneIds(scribe, sceneIds);

  if (!sceneIdsToUse) {
    return;
  }

  let hasUpdated = false;

  sceneIdsToUse.forEach(sceneId => {
    const scene = updatedScribe.scenes.find(scene => scene.id === sceneId);

    if (!scene) return;

    hasUpdated = true;

    let updateDuration = duration ?? scene.settings.sceneTransitionTime;
    let updateType = duration === 0 ? SCENE_TRANSITION_KEY_NONE : scene.settings.sceneTransitionType;
    let updateConfig = duration === 0 ? undefined : scene.settings.sceneTransitionConfig;

    scene.settings = {
      ...scene.settings,
      sceneTransitionType: updateType,
      sceneTransitionTime: updateDuration,
      sceneTransitionConfig: updateConfig
    };
  });

  if (!hasUpdated) {
    return;
  }

  yield put(updateScribe(updatedScribe));
}
